const KEY = (k) => `mw_maplock_${k}`;
const ACTS = ["dragging", "touchZoom", "doubleClickZoom", "scrollWheelZoom", "boxZoom", "keyboard"];

export function addMapLock(map, key) {
  const L = window.L;
  const fit = map.fitBounds.bind(map);
  let locked = false;
  const btn = L.DomUtil.create("button", "");
  btn.type = "button";
  btn.setAttribute("data-testid", `map-lock-${key}`);
  btn.style.cssText = "background:#fff;border:2px solid rgba(0,0,0,.25);border-radius:6px;padding:4px 8px;font:800 11px/1.2 inherit;color:#0f172a;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.25)";
  const zc = () => map.getContainer().querySelector(".leaflet-control-zoom");
  const apply = (on) => {
    locked = on;
    ACTS.forEach((a) => map[a] && map[a][on ? "disable" : "enable"]());
    const z = zc(); if (z) z.style.display = on ? "none" : "";
    map.fitBounds = on ? () => map : fit;
    btn.textContent = on ? "🔒 KİLİTLİ — AÇ" : "🔓 KİLİTLE";
    btn.style.background = on ? "#1d4ed8" : "#fff";
    btn.style.color = on ? "#fff" : "#0f172a";
  };
  L.DomEvent.disableClickPropagation(btn);
  btn.onclick = () => {
    if (locked) { localStorage.removeItem(KEY(key)); apply(false); return; }
    const c = map.getCenter();
    localStorage.setItem(KEY(key), JSON.stringify({ lat: c.lat, lng: c.lng, z: map.getZoom() }));
    apply(true);
  };
  const Ctl = L.Control.extend({ options: { position: "topright" }, onAdd: () => btn });
  map.addControl(new Ctl());
  const saved = JSON.parse(localStorage.getItem(KEY(key)) || "null");
  if (saved) { map.setView([saved.lat, saved.lng], saved.z); apply(true); } else apply(false);
}
